import gql from "graphql-tag";
import { useApolloGqlMutation } from "frontend/hooks/useApolloGql/useApolloGqlMutation.js";

// GQL
const APPROVE_PHOTO_UPLOAD_TITLE = gql`
    mutation approvePhotoUploadTitle($photoUploadId: ID!) {
        payload: approvePhotoUploadTitle(photoUploadId: $photoUploadId) {
            errors
            ok
            photoUpload {
                photoTitleApproved
                photoTitle
            }
        }
    }
`;

const errorHandler = normalizedResp => {
    const { message, errors, actionDesc } = normalizedResp;
    let newMessage = message;

    if (errors.includes("You must add a title before you can approve it.")) {
        newMessage = `Sorry, we were unable to ${actionDesc}. A photo upload title is required and appears to be empty.`;
    }

    return {
        ...normalizedResp,
        message: newMessage
    };
};

export const useApprovePhotoUploadTitle = () => {
    return useApolloGqlMutation({
        actionDesc: "Approve Photo Upload Title",
        gql: APPROVE_PHOTO_UPLOAD_TITLE,
        errorHandler
    });
};
